<!--
分娩孕周分布比例
-->
<template>
  <div class="container">
    <div style="background-color: #fff; padding: 12px 0">
      <div class="my-font-size-16 my-weight-500 titleBox" style="margin: 0 12px">
        <div class="my-primary-color">
          {{ $t('home.gestational_week_distribution') }}
        </div>
        <div>···</div>
      </div>
      <a-divider></a-divider>
      <div class="my-primary-margin">
        <div id="gestationalWeekDistribution" :class="className" :style="{ height: height, width: width }" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
// import resize from './mixins/resize'
export default {
  name: 'GestationalWeekDistribution',
  components: {},
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    }
    // chartData: {
    //   type: Object,
    //   required: true
    // }
  },
  data () {
    return {
      chart: null,
      chartData: {}
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.getChartData()
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getChartData () {
      this.$get('web/chartData/getGAData').then((r) => {
        let data = r.data
        if (data.code === 200) {
          if (data.data) {
            this.chartData = data.data
          }
          this.$forceUpdate()
        } else {
          this.$message.error(data.message)
        }
      })
    },
    initChart () {
      this.chart = echarts.init(document.getElementById('gestationalWeekDistribution'))
      this.setOptions(this.chartData)
    },
    setOptions ({ itemList, titleList } = {}) {
      this.chart.setOption({
        tooltip: {
          trigger: 'item'
        },
        color: ['#2FC25B', '#FACC14', '#F04864', '#ef6567', '#1890FF', '#75bedc'],
        legend: {
          data: titleList,
          orient: 'vertical',
          x: 10,
          y: 'center'
        },
        series: [
          {
            name: '比例',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderWidth: 1, // 间距的宽度
              borderColor: '#fff' // 背景色
            },
            label: {
              show: true,
              position: 'outside',
              fontSize: '12'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              length: 30,
              length2: 15
            },
            data: itemList
          },
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderWidth: 1, // 间距的宽度
              borderColor: '#fff' // 背景色
            },
            label: {
              show: true,
              position: 'inside',
              fontSize: '12',
              color: '#fff',
              formatter: function (d) {
                if (d.value === 0) {
                  return '0%'
                } else {
                  return Math.round(d.percent) + '%'
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              length: 30,
              length2: 15
            },
            data: itemList
          }
        ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
}

.header {
  width: 100%;
  background-color: #fff;
}
.ant-col {
  max-height: 60px !important;
}
.titleBox {
  padding-left: 20px;
  border-left: 4px solid #1890ff;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/home/components/GestationalWeekDistribution.vue